import axios from 'axios'
import { navigate } from '@reach/router'
import { httpStatus } from '../utils/request/httpStatus'
import { getToken, deleteToken } from './autenticacao.servico'
import { transformarRespostaEmCamel } from '../utils/formatter/formatter'
import { URLS } from '../constants'
import { APIS, URLS_APP } from '../config'

export const primeiraVersaoApiary = `/api/v1${URLS_APP.BASE_PATH}`

export const segundaVersaoOEF = '/v2'

export const instanceApiary = axios.create( {
  'baseURL': APIS.APIARY_BASE_URL
} )

export const instanceOEF = axios.create( {
  'baseURL': APIS.OEF_BASE_URL,
  'transformResponse': axios.defaults.transformResponse.concat( dados => transformarRespostaEmCamel( dados ) )
} )

export const instanceApi = axios.create( {
  'baseURL': APIS.ADA_BASE_URL
} )

export const instancePromotionApi = axios.create( {
  'baseURL': APIS.PROMOTION_API_BASE_URL,
  'transformResponse': axios.defaults.transformResponse.concat( dados => transformarRespostaEmCamel( dados ) )
} )

instanceOEF.interceptors.request.use(
  config => {
    if ( config.baseURL === APIS.OEF_BASE_URL && !config.headers.Authorization ) {
      const token = getToken()

      if ( token ) {
        config.headers.Authorization = `Bearer ${token.toString()}`
      }
    }

    return config
  },
  error => Promise.reject( error )
)

instanceOEF.interceptors.response.use(
  response => response,
  erro => {
    if ( erro.response && erro.response.status === httpStatus.UNAUTHORIZED ) {
      deleteToken()
      navigate( URLS_APP.BASE_PATH ? `${URLS_APP.BASE_PATH}/${URLS.LOGIN}` : `/${URLS.LOGIN}` )
    }

    throw erro
  }
)

instanceApiary.interceptors.request.use(
  config => config,
  error => Promise.reject( error )
)

instanceApiary.interceptors.response.use(
  response => response,
  error => Promise.reject( error )
)

instanceApi.interceptors.request.use(
  config => {
    if ( config.baseURL === APIS.ADA_BASE_URL && !config.headers.Authorization ) {
      const token = getToken()

      if ( token ) {
        config.headers.Authorization = `Bearer ${token.toString()}`
      }
    }

    return config
  },
  error => Promise.reject( error )
)

instanceApi.interceptors.response.use(
  response => response,
  erro => {
    if ( erro.response && erro.response.status === httpStatus.UNAUTHORIZED ) {
      deleteToken()
      document.location.reload( true )
    }

    throw erro
  }
)

instancePromotionApi.interceptors.request.use(
  config => {
    if ( config.baseURL === APIS.PROMOTION_API_BASE_URL && !config.headers.Authorization ) {
      const token = getToken()

      if ( token ) {
        config.headers.Authorization = `Bearer ${token.toString()}`
      }
    }

    return config
  },
  error => Promise.reject( error )
)

instancePromotionApi.interceptors.response.use(
  response => response,
  erro => {
    if ( erro.response && erro.response.status === httpStatus.UNAUTHORIZED ) {
      deleteToken()
      navigate( URLS_APP.BASE_PATH ? `${URLS_APP.BASE_PATH}/${URLS.LOGIN}` : `/${URLS.LOGIN}` )
    }

    throw erro
  }
)

